import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getDataWithToken } from "../../../Utils/restUtils";
import { getIndustry, getUserSelect } from "../../../CommonURL";

function UserFilter({ setIsUser, selectedUser, IsUser }) {
  const [userOptions, setUserOptions] = useState([]);

  useEffect(() => {
    userData();
  }, []);
  useEffect(() => {
    if (selectedUser && userOptions.length > 0) {
      const user = userOptions.find((item) => item.value == selectedUser);
      setIsUser(user || null);
    }
  }, [selectedUser, userOptions]);

  const userData = async () => {
    const data = await getDataWithToken(getUserSelect);
    if (data?.status) {
      setUserOptions(
        data.data.map(({ id, user_name }) => ({ value: id, label: user_name })),
      );
    } else {
      handleApiError(data.status);
    }
  };

  const handleChange = (selectedOption) => setIsUser(selectedOption);
  

  return (
    <Select
      options={userOptions}
      onChange={handleChange}
      placeholder="User"
      isClearable
      value={IsUser}
      className="col-sm-12"
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          height: 45,
        }),
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: "rgba(83, 70, 134, 0.474)",
          primary: "#534686",
          primary50: "rgba(83, 70, 134, 0.3)",
        },
      })}
    />
  );
}

export default UserFilter;
